import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { SessionStorageService } from './session-storage.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Api } from '../enum/Api';
import { RenewalData } from '../model/renewal-data';

@Injectable({
  providedIn: 'root'
})
export class EarlyRenewalService {

  constructor(
    private httpService: HttpService,
    private sessionStorageService: SessionStorageService
  ) { }

  public simulateOrInvoice(payload: any): Observable<RenewalData> {
    return this.httpService.post('com.sydle.billing.serasa/advanceDiscount/simulateOrInvoice', Api.One_Portal, payload).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
